module.exports = {"description":"<h2 class=\"mb-2 text-2xl font-bold\">Bienvenue,</h2><p class=\"font-light text-gray-500\">Cet espace de déclaration de service après-vente va vous permettre de déclarer une anomalie, prendre rendez-vous pour gérer ce problème et consulter le suivi de votre déclaration.</p>","nouveau_sav":"Nouveau SAV","je_souhaite_faire_une_nouvelle_declaration_de_sav":"Je souhaite faire une nouvelle déclaration de SAV !","me_connecter":"Me connecter","je_possede_deja_un_compte":"Je possède déjà un compte"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/default/fr/home/welcome.lang.json
// module id = L0mf
// module chunks = 1